import { ExerciseControllerApi } from "src/api/api/exercise-controller-api";

export interface IExerciseApiClients {
    exercise: ExerciseControllerApi;
}
export class ExerciseApiClients {
    private static instance: IExerciseApiClients;
  
    private constructor() {}
  
    static getInstance(basePath: string): IExerciseApiClients {
      if (ExerciseApiClients.instance == null) {
        ExerciseApiClients.instance = {
        exercise: new ExerciseControllerApi({
            basePath: basePath,
            isJsonMime() {
              return true;
            }
          }),
        };
      }
      return ExerciseApiClients.instance;
    }
  }
  